import React from 'react';
import { motion } from 'framer-motion';
import { styles } from '../styles';
import { SectionWrapper } from '../hoc';
import { textVariant, fadeIn } from '../utils/motion';
import { testimonials } from '../constants';

const Avatar = ({ image, name }) => {
	if (image) {
		return (
			<img
				src={image}
				alt={name}
				className="w-12 h-12 rounded-full object-cover border-2 border-border"
			/>
		);
	}
	const initials = name.split(' ').map(n => n[0]).join('').slice(0, 2);
	return (
		<div className="w-12 h-12 rounded-full bg-accent/10 border-2 border-border flex items-center justify-center">
			<span className="text-accent text-[14px] font-bold">{initials}</span>
		</div>
	);
};

const FeedbackCard = ({ index, testimonial, name, designation, company, image }) => (
	<motion.div
		variants={fadeIn('up', 'tween', index * 0.1, 0.4)}
		className="bg-warm border border-border rounded-xl p-6 hover:border-accent/20 transition-colors duration-300">
		<svg className="w-8 h-8 text-accent/20 mb-4" fill="currentColor" viewBox="0 0 24 24">
			<path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z" />
		</svg>
		<p className="text-muted text-[14px] leading-relaxed">
			{testimonial}
		</p>
		<div className="mt-5 flex items-center gap-3 pt-4 border-t border-border/50">
			<Avatar image={image} name={name} />
			<div>
				<p className="text-primary text-[14px] font-semibold">{name}</p>
				<p className="text-muted text-[12px]">{designation}, {company}</p>
			</div>
		</div>
	</motion.div>
);

const Feedbacks = () => {
	return (
		<>
			<motion.div variants={textVariant()}>
				<p className={styles.sectionSubText}>Colleagues</p>
				<h2 className={styles.sectionHeadText}>What People Say</h2>
			</motion.div>

			<motion.p
				variants={fadeIn('', '', 0.1, 0.4)}
				className="mt-4 text-muted text-[15px] max-w-2xl leading-[26px]">
				Recommendations from engineers, managers, and product leads I have worked with.
			</motion.p>

			<div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
				{testimonials.map((t, index) => (
					<FeedbackCard
						key={t.name}
						index={index}
						{...t}
					/>
				))}
			</div>
		</>
	);
};

export default SectionWrapper(Feedbacks, 'testimonials');
